(function () {
    window.eventsService  = {
      get() {
        return axios.get(`/api/events/get.php`);
      },
      save(data) {
        return axios.post('/api/events/save.php', data);
      },
      deleteTask(data) {
        return axios({
            method: 'delete',
            url: '/api/events/save.php',
            data: data
        });
      },
      updateTaskOrder(data){
        return axios.post('/api/events/update-task-order', data);
      },
      getActiveUserEvents(data){
        return axios.get('/api/user/events/get.php');
      },
      getEvent(data){
          return axios.get(`/api/events/get.php?code=${data}`);
      },
      saveUserEvent(data){
        return axios.post('/api/user/events/save.php', data);
      },
      saveProcessedRewards(data){
        return axios.post('/api/user/events/save_rewards.php', data);
      },
    };
  })();
  